<div
  class="mat-snack-bar-container mat-snackbar mat-snack-bar-top"
  style="transform: scale(1); opacity: 1"
>
  <div class="notification-container" (click)="action()">
    <div class="notification-container__header">
      <div
        style="display: flex; align-items: center; justify-content: flex-start"
      >
        <mat-icon
          *ngIf="data.type == 'success'"
          class="notification-container__icon"
          id="success"
          >check_circle</mat-icon
        >
        <mat-icon
          *ngIf="data.type == 'info'"
          class="notification-container__icon"
          id="info"
          >info</mat-icon
        >
        <mat-icon
          *ngIf="data.type == 'danger'"
          class="notification-container__icon"
          id="daner"
          >error</mat-icon
        >
        <mat-icon
          *ngIf="data.type == 'warning'"
          class="notification-container__icon"
          id="warning"
          >warning</mat-icon
        >
        <mat-icon
          *ngIf="data.type == 'callBack' || data.type == 'dup'"
          class="notification-container__icon"
          id="call-back"
          >notifications_active</mat-icon
        >
        <span class="notification-container__title">{{ data.title }}</span>
      </div>
      <mat-icon class="notification-container__close" (click)="close($event)"
        >close</mat-icon
      >
    </div>
    <div
      class="notification-container__message"
      [innerHTML]="data.message"
    ></div>
  </div>
</div>
